import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does it cost to develop a telemedicine app?",
    answer: `<p>The cost of developing a telemedicine app typically ranges from $75,000 to $250,000, with pricing influenced by factors such as the app's type, complexity, team expertise, and geographical location.</p>`,
  },
  {
    question: "What would make a successful telehealth app?",
    answer: `<p>Here are the key features of a successful telehealth application:</p> <ul>
    <li>Secure login and verification</li>
    <li>Appointment booking for telehealth services</li>
    <li>Insurance validation</li>
    <li>Live video and audio conferencing</li>
    <li>Access to medical records via telehealth platforms</li>
    <li>Management of prescriptions within the system</li>
    </ul>`,
  },
  {
    question: "Can telemedicine be profitable?",
    answer: `<p>Numerous telemedicine firms offer bi-weekly payment for rendered services. On average, telemedicine physicians earn between $15 and $30 per video consultation and can typically conduct 3-5 consultations per hour, resulting in an hourly income ranging from $100 to $150. Similarly, telemedicine nurse practitioners typically earn $23 per consultation, translating to an hourly income averaging between $60 and $100.</p>`,
  },
  {
    question: "How do I create a telemedicine platform?",
    answer: `<p>The following are the core steps to developing a telemedicine platform:</p> <ul>
    <li>Project Planning</li>
    <li>Discovery Phase</li>
    <li>UI/UX Design Prototyping</li>
    <li>Product Development</li>
    <li>Testing</li>
    <li>Delivery and Maintenance</li>
    </ul>`,
  },
  {
    question: "Is there an increase in demand for telehealth services?",
    answer: `<p>The demand for telehealth services has surged across the 50 countries most impacted by the COVID-19 pandemic, underscoring the necessity to expand telehealth capabilities both during and after the pandemic period.</p>`,
  },
  {
    question: "How much does a telehealth platform cost?",
    answer: `<p>The primary necessity for a telemedicine platform is its compliance with HIPAA regulations. The cost of healthcare business software varies between $50,000 and $300,000 depending on the intricacy of the incorporated features.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Telemedicine App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
